module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/additional-briefing-clan-landing-elite-sm.5e3b290a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/additional-briefing-clan-landing-elite-sm.png
// module id = 3688
// module chunks = 11